import React, { useMemo, useCallback } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";

function AddressField({
  label,
  dirKey,
  coordsKey,
  value,
  onChange,
  suggestDireccion,
}) {
  // handler estable
  const handleSearch = useCallback(() => {
    suggestDireccion(dirKey, coordsKey);
  }, [dirKey, coordsKey, suggestDireccion]);

  // adornment estable: NO crear JSX inline en cada render
  const adornment = useMemo(
    () => (
      <InputAdornment position="end">
        <IconButton
          aria-label={`buscar ${label}`}
          onClick={handleSearch}
          // importante: el nodo sigue siendo el mismo; solo cambia la prop
          disabled={!value || value.trim().length < 8 || !window.google?.maps}
          edge="end"
          title="Buscar dirección"
        >
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path
              d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16
                   c1.61 0 3.09-.59 4.23-1.57l.27.28v.79L20 21.5 21.5 20 15.5 14zm-6
                   0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
            />
          </svg>
        </IconButton>
      </InputAdornment>
    ),
    [handleSearch, value]
  );

  return (
    <TextField
      id={dirKey}
      name={dirKey}
      label={label}
      value={value}
      onChange={onChange} // ← solo estado; nada de Google aquí
      variant="outlined"
      fullWidth
      inputProps={{ maxLength: 200 }}
      InputProps={{ endAdornment: adornment }}
    />
  );
}

// (opcional) Memoriza todo el campo para que no se vuelva a montar
export default React.memo(AddressField);
